import { QPointDrawingComponent } from '../../../../projects/qpoint-drawing/src/lib/drawing/drawing.component';

import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { QPointContentContainerComponent, QPointToolbarComponent } from '@qpoint/layout';
import { QPointPagedMultiPolygon } from '../../../../projects/qpoint-drawing/src/lib/drawing/qpoint-paged-multi-polygon';
import {
  ContextMenuModule,
  ContextMenuSelectEvent,
  MenuItem
} from "@progress/kendo-angular-menu";
import * as K from "@progress/kendo-angular-menu";
import { ScaleDialogData } from '../../../../projects/qpoint-drawing/src/lib/drawing/components/scale-dialog/scale-dialog.component';

interface MenuItemWithId extends MenuItem {
  id?: number;
}
@Component({
    selector: "app-pdf-polygon-binding",
    templateUrl: "./pdf-polygon-binding.component.html",
    styleUrls: ["./pdf-polygon-binding.component.scss"],
    encapsulation: ViewEncapsulation.None,
    imports: [
        QPointToolbarComponent,
        QPointContentContainerComponent,
        QPointDrawingComponent,
        ContextMenuModule,
    ]
})
export class ControlGalleryPdfPolygonBindingComponent implements OnInit {
  public polygons: QPointPagedMultiPolygon[];
  public activePage: number;

  public polygons1: QPointPagedMultiPolygon[];
  public activePage1: number;

  public polygons2: QPointPagedMultiPolygon[];
  public activePage2: number;

  public polygons3: QPointPagedMultiPolygon[];
  public activePage3: number;

  public isDrawingEnabled: boolean = false;

  scaleData: ScaleDialogData = {
    referenceLength: null,
    realLength: 10,
  }

  constructor() {}

  @ViewChild("gridMenu")
  public gridMenu: K.ContextMenuComponent;

  @ViewChild("qpointDrawing")
  qpointDrawing: QPointDrawingComponent;

  ngOnInit() {
    this.polygons1 = [
      {
        multiPolygon: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [-48.84999942779541, -55.4946203778174],
                [-67.34999942779541, -24.4893261464631],
                [-86.09999942779541, -65.49632819438331],
              ],
            ],
          ],
        },
        page: 1,
      },
    ];
    this.activePage1 = 1;

    this.polygons2 = [
      {
        multiPolygon: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [-48.84999942779541, -55.4946203778174],
                [-67.34999942779541, -24.4893261464631],
                [-86.09999942779541, -45.49632819438331],
                [-86.09999942779541, -65.49632819438331],
              ],
            ],
          ],
        },
        page: 1,
      },
    ];
    this.activePage2 = 2;

    this.polygons3 = null;
    this.activePage3 = null;
  }

  public goToStep(number) {
    switch (number) {
      case 1:
        this.polygons = this.polygons1;
        this.activePage = this.activePage1;
        break;
      case 2:
        this.polygons = this.polygons2;
        this.activePage = this.activePage2;
        break;
      case 3:
        this.polygons = this.polygons3;
        this.activePage = this.activePage3;
        break;
    }
  }

  public items: MenuItemWithId[] = [{ text: "select" }, { text: "delete" }, { text: 'scale' }];

  public onSelect(event: ContextMenuSelectEvent): void {
    console.log(event);
    if (event.item.text === "select") {
      console.log("select event");
    } else if (event.item.text === "delete") {
      console.log("delete event");
      this.qpointDrawing.deletePolygon(event.item.id);
    }

    if(event.item.text === 'scale') {
      this.qpointDrawing.toggleScaleWindow();
    }
  }

  public mapRightClick(event: any) {
    console.log("map right click", event);
    this.gridMenu.show({
      left: event.x,
      top: event.y,
    });
  }

  public polygonRightClick(event: any) {
    console.log("polygon right click", event);
    this.items = [{ text: "select" }, { text: "delete", id: event.polygonId }];
    this.gridMenu.show({
      left: event.x,
      top: event.y,
    });
  }

  public onPolygonsChanged(event) {
    this.polygons = event;
  }

  public onActivePageChanged(event) {
  }

  public toggleDrawingEnabled() {
    this.isDrawingEnabled = !this.isDrawingEnabled;
  }

  public onAreaCalculated(event: number) {
  }
}
